import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from '../../../style'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: ${({ height }) => ((typeof height === 'string') ? height : `${height}px`)};
  width: ${({ width }) => ((typeof width === 'string') ? width : `${width}px`)};
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
  flex-wrap: ${({ flexWrap }) => flexWrap};
  align-self: ${({ alignSelf }) => alignSelf};
  background-color: ${({ bgColor }) => theme[bgColor]};
  border: ${({ border }) => (border ? `1px solid ${theme.red}` : null)}
`

const Row = ({
    height,
    width,
    alignItems,
    justifyContent,
    flexWrap,
    alignSelf,
    bgColor,
    border,
    ...rest
}) => (
    <Container
        width={width}
        height={height}
        alignItems={alignItems}
        justifyContent={justifyContent}
        flexWrap={flexWrap}
        alignSelf={alignSelf}
        bgColor={bgColor}
        border={border}
        {...rest}
    />
)

Row.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    alignItems: PropTypes.oneOf([
        'center',
        'flex-start',
        'flex-end',
        'stretch',
    ]),
    justifyContent: PropTypes.oneOf([
        'center',
        'flex-start',
        'flex-end',
        'space-between',
        'space-around',
        'space-evenly',
    ]),
    flexWrap: PropTypes.oneOf([
        'nowrap',
        'wrap',
        'wrap-reverse',
    ]),
    alignSelf: PropTypes.oneOf([
        'auto',
        'flex-start',
        'flex-end',
        'center',
        'stretch',
        'baseline',
    ]),
    bgColor: PropTypes.oneOf(Object.keys(theme)),
    border: PropTypes.bool,
    // Plus all native div component props
}

Row.defaultProps = {
    width: 'auto',
    height: 'auto',
    bgColor: 'transparent',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    alignSelf: 'stretch',
    border: false,
}

export default Row
